import { useEffect, useState } from "react";
import { Navigate, useNavigate, Routes, Route } from "react-router-dom";
import Sidebar from "./pages/global/Sidebar";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import { ReactSession } from "react-client-session";
import Topbar from "./pages/global/Topbar.jsx";

import Login from "./pages/Login.jsx";

import Welcome from "./pages/Welcome.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import User from "./pages/User.jsx";



function App() {
  const [theme, colorMode] = useMode();
  const [loggedIn, setLoggedIn] = useState(false);
  const [isSidebar, setIsSidebar] = useState(true);
  ReactSession.setStoreType("localStorage");
  const navigate = useNavigate();
  const username = ReactSession.get("username");

  const handleLogin = () => {
    if (username && username !== "") {
      setLoggedIn(true);
      navigate("/");
    }
  };

  useEffect(() => {
    // eslint-disable-next-line
    handleLogin();
    // eslint-disable-next-line
  }, [username]);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          {loggedIn ? (
            <>
              <Sidebar isSidebar={isSidebar} />
              <main className="content">
                <Topbar setIsSidebar={setIsSidebar} />
                <Routes>
                  <Route
                    path="/"
                    element={
                      ReactSession.get("role") === "admin" ? (
                        <Dashboard />
                      ) : (
                        <Welcome />
                      )
                    }
                  />
                  <Route
                    path="/login"
                    element={
                      loggedIn ? (
                        <Navigate to="/" />
                      ) : (
                        <Login onLogin={handleLogin} />
                      )
                    }
                  />
                  {ReactSession.get("role") == "admin" ? (
                    <Route path="/utilisateur" element={<User />} />
                  ) : null}
                  {ReactSession.get("role") == "admin" ? (
                    <Route path="/configuration" element={<Dashboard />} />
                  ) : null}
                </Routes>
              </main>
            </>
          ) : (
            <main className="content">
              <Routes>
                <Route
                  path="/login"
                  element={<Login onLogin={handleLogin} />}
                />
                <Route path="/*" element={<Navigate to="/login" />} />
              </Routes>
            </main>
          )}
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
